export default __webpack_public_path__ + "static/media/my.4188f455.svg";